<template>                    
    
    <v-layout row>
        <v-flex xs5>
            <v-select                        
                label="Auswahl Firmen"
                autocomplete
                v-bind:async-loading="loading"
                dark
                multiple
                cache-items
                chips
                required
                v-bind:items="firmen"     
                item-text="name"
                item-value="id"
                return-object
                v-bind:search-input.sync="search"
                v-model="mk.firmen"></v-select>
        </v-flex>

        <v-flex xs6 offset-xs1> 
            <v-layout row wrap>
                <v-flex xs6 v-for="(firma,index) in mk.firmen" v-bind:key="index">
                    <p><strong> {{ firma.name }} </strong></p>
                    <p> {{ firma.adressen[0].strasse }} </br>
                    {{ firma.adressen[0].plz }} {{ firma.adressen[0].ort }} </p>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {           
                 
            search: null,               
        };
    },
    watch: {
      search (val) {
        val && this.querySelections(val)
      }
    },
    /*created: function(){
        this.$store.dispatch('setFirmen')
        
    },*/
    computed: {
        firmen: function() {
            
            return this.$store.getters.firmen
        },
        mk: function() {
            return this.$store.getters.marke
        },
        loading: function() {
            return this.$store.getters.loading
        }
        
        
    },
    methods: {

        querySelections (v) {
            //this.loading = true               
            this.mk.firmen = this.firmen.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })
            //this.loading = false
        
        },
              
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// firmenSelect.vue?607b62d4